/* Calm Loops theme script: hoop illustrations, buy box (single kit or 2-kit bundle), phrases, stars. */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function rng(seed) { return function () { seed |= 0; seed = seed + 0x6D2B79F5 | 0; var t = Math.imul(seed ^ seed >>> 15, 1 | seed); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  function hash(i, j, k) { var h = (i * 374761393 + j * 668265263 + k * 1442695041) | 0; h = Math.imul(h ^ (h >>> 13), 1274126177); return ((h ^ (h >>> 16)) >>> 0) / 4294967296; }
  var hexCache = {};
  function rgb(hex) { if (hexCache[hex]) return hexCache[hex]; var n = parseInt(hex.slice(1), 16); return (hexCache[hex] = [n >> 16 & 255, n >> 8 & 255, n & 255]); }
  function shade(c, amt) { var t = amt < 0 ? 0 : 255, p = Math.abs(amt); return [Math.round(c[0] + (t - c[0]) * p), Math.round(c[1] + (t - c[1]) * p), Math.round(c[2] + (t - c[2]) * p)]; }
  function css(c) { return 'rgb(' + c[0] + ',' + c[1] + ',' + c[2] + ')'; }
  function sq(v) { return v * v; }

  /* ---------- original designs: color of each loop at (x, y) inside a -1..1 circle ---------- */
  var D = {
    meadow: function (x, y, i, j) {
      var hill = 0.06 + 0.12 * Math.sin(x * 2.2 + 0.6);
      if (y < hill) {
        if (sq(x - 0.4) + sq(y + 0.46) < 0.03 && !(sq(x - 0.47) + sq(y + 0.51) < 0.022)) return '#F1E4B8';
        if (hash(i, j, 1) < 0.04) return '#F2D37A';
        return y < -0.35 ? '#232B57' : '#2E3A6E';
      }
      var h = hash(i, j, 2);
      if (h < 0.15) return '#F2C14E';
      if (h < 0.23) return '#F6EFE2';
      if (h < 0.28) return '#E58C8A';
      return y < hill + 0.2 ? '#4F7A55' : '#3F6A4A';
    },
    sunmoon: function (x, y, i, j) {
      if (x < 0) {
        var ds = Math.hypot(x + 0.42, y);
        if (ds < 0.25) return '#F29E38';
        if (ds > 0.31 && ds < 0.42) { var a = Math.atan2(y, x + 0.42); if (Math.cos(a * 8) > 0.25) return '#F7CE6A'; }
        return y > 0.55 ? '#E9A46B' : '#F6C79A';
      }
      if (Math.hypot(x - 0.42, y) < 0.25 && Math.hypot(x - 0.53, y + 0.08) > 0.2) return '#F1E6CC';
      if (hash(i, j, 3) < 0.05) return '#F2D37A';
      return y > 0.55 ? '#26305C' : '#34406E';
    },
    butterfly: function (x, y) {
      var ax = Math.abs(x);
      if (ax < 0.045 && y > -0.36 && y < 0.36) return '#2B2A33';
      if (y < -0.34 && y > -0.62 && Math.abs(ax - (0.03 + (-0.34 - y) * 0.55)) < 0.035) return '#2B2A33';
      var e1 = sq((ax - 0.34) / 0.3) + sq((y + 0.15) / 0.27);
      var e2 = sq((ax - 0.25) / 0.21) + sq((y - 0.25) / 0.18);
      var e = Math.min(e1, e2);
      if (e < 1) {
        if (e > 0.7) return (Math.sin(x * 34) * Math.sin(y * 34) > 0.55) ? '#F6EFE2' : '#2B2A33';
        if (e1 < 0.22) return '#F2B54A';
        return e1 < 1 ? '#E5793A' : '#D7672F';
      }
      return y > 0.5 ? '#9DBB97' : '#B3CDAC';
    },
    beach: function (x, y, i, j) {
      var wave = -0.06 + 0.04 * Math.sin(x * 6);
      var ux = x + 0.34, uy = y - 0.3;
      if (uy < 0 && uy > -0.3 && ux * ux + uy * uy < 0.09) { var a = Math.atan2(uy, ux); return (Math.floor((a + Math.PI) / (Math.PI / 6)) % 2) ? '#D9534F' : '#F7F1E6'; }
      if (Math.abs(ux) < 0.024 && uy >= 0 && uy < 0.3) return '#6B4F3A';
      if (y < wave) {
        if (Math.hypot(x - 0.45, y + 0.5) < 0.15) return '#F7C548';
        if (sq(x + 0.3) / 0.07 + sq(y + 0.52) / 0.008 < 1 || sq(x + 0.12) / 0.04 + sq(y + 0.58) / 0.006 < 1) return '#F7F4EC';
        return '#A6D1E6';
      }
      var shore = 0.3 + 0.05 * Math.sin(x * 4 + 1);
      if (y < shore) return Math.sin(y * 38 + x * 5) > 0.86 ? '#CFE6EE' : (y < 0.12 ? '#3F86A8' : '#4C9AB8');
      return hash(i, j, 4) < 0.05 ? '#F2EBDD' : '#E8CFA0';
    },
    duck: function (x, y) {
      if (Math.hypot(x + 0.33, y + 0.2) < 0.045) return '#2B2A33';
      if (sq((x + 0.56) / 0.12) + sq((y + 0.1) / 0.055) < 1) return '#F0A23B';
      if (Math.hypot(x + 0.3, y + 0.16) < 0.21) return '#FBF7EF';
      var body = sq((x - 0.08) / 0.52) + sq((y - 0.28) / 0.3);
      if (body < 1) return (sq((x - 0.15) / 0.3) + sq((y - 0.24) / 0.15) < 1) ? '#E6DECD' : '#FBF7EF';
      if (y > 0.6) return '#7FA36A';
      if (sq((x - 0.4) / 0.25) + sq((y + 0.5) / 0.1) < 1 || sq((x - 0.24) / 0.15) + sq((y + 0.58) / 0.09) < 1) return '#F3F6F8';
      return '#A8C6E0';
    },
    paw: function (x, y) {
      var hx = x / 0.16, hy = -(y + 0.6) / 0.16 + 0.3;
      if (hx * hx + sq(hy - Math.sqrt(Math.abs(hx))) < 1) return '#D64550';
      if (sq(x / 0.17) + sq((y - 0.31) / 0.12) < 1) return '#E8909C';
      if (sq(x / 0.3) + sq((y - 0.28) / 0.24) < 1) return '#FBF5EC';
      var toes = [[-0.36, -0.02], [-0.13, -0.2], [0.13, -0.2], [0.36, -0.02]];
      for (var t = 0; t < toes.length; t++) { var d = Math.hypot(x - toes[t][0], y - toes[t][1]); if (d < 0.065) return '#E8909C'; if (d < 0.12) return '#FBF5EC'; }
      return y > 0.62 ? '#E39C98' : '#EBAFAA';
    }
  };

  /* ---------- hoop renderer: wooden ring, oatmeal cloth, yarn loops ---------- */
  function drawHoop(cv, key) {
    var f = D[key] || D.meadow;
    var w = cv.getBoundingClientRect().width;
    if (!w) return;
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var S = Math.round(w * dpr);
    if (cv.width !== S) { cv.width = S; cv.height = S; }
    var ctx = cv.getContext('2d');
    ctx.clearRect(0, 0, S, S);
    var cx = S / 2, cy = S / 2 + S * 0.012, R = S * 0.465, wood = R * 0.075, rin = R - wood;

    ctx.save();
    ctx.beginPath(); ctx.arc(cx, cy, rin, 0, Math.PI * 2); ctx.fillStyle = '#D9CEB7'; ctx.fill(); ctx.clip();
    ctx.strokeStyle = 'rgba(110,90,60,0.13)'; ctx.lineWidth = Math.max(1, S / 600);
    var st = Math.max(2.5, S / 110), p;
    for (p = -rin; p <= rin; p += st) { ctx.beginPath(); ctx.moveTo(cx + p, cy - rin); ctx.lineTo(cx + p, cy + rin); ctx.stroke(); ctx.beginPath(); ctx.moveTo(cx - rin, cy + p); ctx.lineTo(cx + rin, cy + p); ctx.stroke(); }

    var rand = rng(key.length * 9973 + key.charCodeAt(0));
    var n = S < 140 ? 15 : 26;
    var s = rin / n, rowH = s * Math.sqrt(3) / 2, r = s * 0.68, j = 0, y, x, i;
    for (y = -rin; y <= rin; y += rowH, j++) {
      var off = (j % 2) ? s / 2 : 0; i = 0;
      for (x = -rin + off; x <= rin; x += s, i++) {
        var nx = x / rin, ny = y / rin;
        if (nx * nx + ny * ny > 0.885) { rand(); rand(); rand(); continue; }
        var hex = f(nx, ny, i, j);
        var jx = (rand() - 0.5) * s * 0.2, jy = (rand() - 0.5) * s * 0.2, v = rand();
        if (!hex) continue;
        var base = shade(rgb(hex), (v - 0.5) * 0.14);
        var px = cx + x + jx, py = cy + y + jy;
        var g = ctx.createRadialGradient(px - r * 0.35, py - r * 0.4, r * 0.08, px, py, r);
        g.addColorStop(0, css(shade(base, 0.3))); g.addColorStop(0.55, css(base)); g.addColorStop(1, css(shade(base, -0.34)));
        ctx.fillStyle = g; ctx.beginPath(); ctx.ellipse(px, py, r, r * 0.9, 0, 0, Math.PI * 2); ctx.fill();
        ctx.fillStyle = css(shade(base, -0.5)); ctx.globalAlpha = 0.45;
        ctx.beginPath(); ctx.ellipse(px + r * 0.05, py + r * 0.14, r * 0.22, r * 0.15, 0, 0, Math.PI * 2); ctx.fill();
        ctx.globalAlpha = 1;
      }
    }
    ctx.restore();

    var wg = ctx.createLinearGradient(cx - R, cy - R, cx + R, cy + R);
    wg.addColorStop(0, '#E6C48E'); wg.addColorStop(0.5, '#C99A5E'); wg.addColorStop(1, '#A57543');
    ctx.lineWidth = wood; ctx.strokeStyle = wg; ctx.beginPath(); ctx.arc(cx, cy, R - wood / 2, 0, Math.PI * 2); ctx.stroke();
    ctx.lineWidth = Math.max(1, wood * 0.1); ctx.strokeStyle = 'rgba(80,52,25,0.35)';
    ctx.beginPath(); ctx.arc(cx, cy, rin, 0, Math.PI * 2); ctx.stroke();
    ctx.beginPath(); ctx.arc(cx, cy, R - wood * 0.52, 0, Math.PI * 2); ctx.stroke();
    ctx.strokeStyle = 'rgba(255,244,220,0.4)'; ctx.lineWidth = wood * 0.22;
    ctx.beginPath(); ctx.arc(cx, cy, R - wood * 0.28, Math.PI * 1.08, Math.PI * 1.55); ctx.stroke();

    var cw = wood * 1.5, ch = wood * 1.7, top = cy - R - ch * 0.32;
    var mg = ctx.createLinearGradient(cx - cw / 2, 0, cx + cw / 2, 0);
    mg.addColorStop(0, '#9E9789'); mg.addColorStop(0.5, '#D8D2C4'); mg.addColorStop(1, '#8C8577');
    ctx.fillStyle = mg; ctx.beginPath();
    if (ctx.roundRect) ctx.roundRect(cx - cw / 2, top, cw, ch, cw * 0.18); else ctx.rect(cx - cw / 2, top, cw, ch);
    ctx.fill();
    ctx.fillStyle = '#7D7669'; ctx.beginPath(); ctx.arc(cx, top + ch * 0.32, cw * 0.16, 0, Math.PI * 2); ctx.fill();
  }

  function drawAll() {
    var list = document.querySelectorAll('canvas[data-design]');
    for (var k = 0; k < list.length; k++) drawHoop(list[k], list[k].getAttribute('data-design'));
  }

  /* ---------- buy box ---------- */
  function initBuyBox(root) {
    var form = root.querySelector('form');
    if (!form) return;
    var currency = root.getAttribute('data-currency') || 'USD';
    var off = Math.round(parseFloat(root.getAttribute('data-bundle-off') || '0') * 100);
    var addUrl = root.getAttribute('data-add-url');
    var cartUrl = root.getAttribute('data-cart-url');
    var fmt;
    try { var nf = new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }); fmt = function (c) { return nf.format(c / 100); }; }
    catch (e) { fmt = function (c) { return '$' + (c / 100).toFixed(2); }; }

    var media = root.querySelector('[data-main-media]');
    var mainImg = root.querySelector('[data-main-img]');
    var mainCanvas = root.querySelector('[data-main-canvas]');
    var priceEl = root.querySelector('[data-price]');
    var oneEl = root.querySelector('[data-one-price]');
    var bundleEl = root.querySelector('[data-bundle-price]');
    var bundleWasEl = root.querySelector('[data-bundle-was]');
    var nameEl = root.querySelector('[data-option-name]');
    var name2El = root.querySelector('[data-option-name-2]');
    var secondWrap = root.querySelector('[data-second]');
    var sameBox = root.querySelector('[data-same-box]');
    var addBtn = root.querySelector('[data-add]');
    var msg = root.querySelector('[data-buy-msg]');

    function selected(name) {
      var r = form.querySelector('input[name="' + name + '"]:checked') || form.querySelector('input[type="hidden"][name="' + name + '"]');
      if (r) return r;
      var sel = form.querySelector('select[name="' + name + '"]');
      return sel ? sel.options[sel.selectedIndex] : null;
    }
    var subPriceEl = root.querySelector('[data-sub-price]');
    var planInput = root.querySelector('[data-selling-plan]');
    var subNote = root.querySelector('[data-sub-note]');
    function mode() { var q = form.querySelector('input[name="cl_qty"]:checked'); return q ? q.value : '1'; }
    function subCents(el) { var v = el && el.getAttribute('data-sub-price-cents'); return v ? parseInt(v, 10) : null; }
    function showMedia(el) {
      if (!media || !el) return;
      var img = el.getAttribute('data-img');
      if (img && mainImg) {
        mainImg.src = img; mainImg.removeAttribute('srcset'); mainImg.alt = el.getAttribute('data-title') || '';
        mainImg.hidden = false; if (mainCanvas) mainCanvas.hidden = true; media.classList.add('has-img');
      } else if (mainCanvas && !media.hasAttribute('data-keep-img')) {
        mainCanvas.setAttribute('data-design', el.getAttribute('data-design') || 'meadow');
        mainCanvas.hidden = false; if (mainImg) mainImg.hidden = true; media.classList.remove('has-img');
        drawHoop(mainCanvas, mainCanvas.getAttribute('data-design'));
      }
    }
    function update(changedName) {
      var a = selected('id');
      if (!a) return;
      var m = mode();
      var pa = parseInt(a.getAttribute('data-price-cents'), 10) || 0;
      var availA = a.getAttribute('data-available') === 'true';
      if (nameEl) nameEl.textContent = a.getAttribute('data-title') || '';
      if (oneEl) oneEl.textContent = fmt(pa);
      var sa = subCents(a);
      if (subPriceEl && sa !== null) subPriceEl.textContent = fmt(sa);
      var total = pa, avail = availA, label = 'Add to bag · ' + fmt(pa);
      var b = selected('cl_id2');
      if (b) {
        var pb = parseInt(b.getAttribute('data-price-cents'), 10) || 0;
        if (name2El) name2El.textContent = b.getAttribute('data-title') || '';
        if (bundleEl) bundleEl.textContent = fmt(pa + pb - off);
        if (bundleWasEl) bundleWasEl.textContent = fmt(pa + pb);
        if (m === '2') {
          total = pa + pb - off;
          avail = availA && b.getAttribute('data-available') === 'true';
          label = 'Add 2 kits to bag · ' + fmt(total);
        }
      }
      if (m === 'sub') {
        total = sa !== null ? sa : pa;
        label = 'Join the club · ' + fmt(total) + ' / month';
      }
      if (planInput) planInput.disabled = (m !== 'sub');
      if (subNote) subNote.hidden = (m !== 'sub');
      if (secondWrap) { var wasHidden = secondWrap.hidden; secondWrap.hidden = (m !== '2'); if (wasHidden && m === '2') drawAll(); }
      if (sameBox) sameBox.hidden = (m !== '2');
      if (priceEl) priceEl.textContent = fmt(total) + (m === 'sub' ? ' / month' : '');
      if (addBtn) { addBtn.disabled = !avail; addBtn.textContent = avail ? label : 'Sold out'; }
      if (changedName === 'id' || !changedName) { showMedia(a); filterThumbs(a.getAttribute('data-title') || ''); }
      if (changedName === 'cl_id2' && b) showMedia(b);
      if (msg) msg.hidden = true;
    }
    form.addEventListener('change', function (e) { update(e.target && e.target.name); });
    form.addEventListener('submit', function (e) {
      if (mode() !== '2') return;
      e.preventDefault();
      var a = selected('id'), b = selected('cl_id2');
      if (!a || !b) return;
      addBtn.disabled = true;
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(a.value, 10), quantity: 1 }, { id: parseInt(b.value, 10), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = cartUrl;
      }).catch(function () {
        addBtn.disabled = false;
        if (msg) { msg.textContent = 'We couldn\'t add both kits. One of the designs may be sold out. Try another design.'; msg.hidden = false; }
      });
    });

    function filterThumbs(title) {
      var all = root.querySelectorAll('[data-thumb]');
      if (!all.length) return;
      var key = title.trim().toLowerCase(), matched = 0, q;
      for (q = 0; q < all.length; q++) { if ((all[q].getAttribute('data-group') || '').trim().toLowerCase() === key) matched++; }
      for (q = 0; q < all.length; q++) {
        var g = (all[q].getAttribute('data-group') || '').trim().toLowerCase();
        all[q].hidden = matched > 0 && g !== key && g !== 'all';
        all[q].setAttribute('aria-current', 'false');
      }
    }
    var thumbs = root.querySelectorAll('[data-thumb]');
    for (var t = 0; t < thumbs.length; t++) {
      thumbs[t].addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = this.getAttribute('data-thumb'); mainImg.removeAttribute('srcset'); mainImg.hidden = false;
        if (mainCanvas) mainCanvas.hidden = true; media.classList.add('has-img');
        for (var q = 0; q < thumbs.length; q++) thumbs[q].setAttribute('aria-current', thumbs[q] === this ? 'true' : 'false');
      });
    }
    update();
  }

  /* ---------- phrases ---------- */
  function initPhrases(root) {
    var el = root.querySelector('[data-phrase]');
    var items = root.querySelectorAll('[data-phrase-list] li');
    var btn = root.querySelector('[data-next-phrase]');
    if (!el || !items.length) return;
    var list = [], k;
    for (k = 0; k < items.length; k++) list.push(items[k].textContent);
    var idx = 0;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function next() {
      idx = (idx + 1) % list.length;
      if (reduce) { el.textContent = list[idx]; return; }
      el.style.opacity = '0';
      setTimeout(function () { el.textContent = list[idx]; el.style.opacity = '1'; }, 450);
    }
    if (btn) btn.addEventListener('click', next);
    if (!reduce && list.length > 1) setInterval(function () { if (!document.hidden) next(); }, 9000);
  }

  function initStars(root) {
    var box = root.querySelector('[data-stars]');
    if (!box || box.childElementCount) return;
    var sr = rng(42);
    for (var k = 0; k < 26; k++) { var s = document.createElement('i'); s.style.left = (sr() * 100) + '%'; s.style.top = (sr() * 100) + '%'; s.style.opacity = (0.25 + sr() * 0.6).toFixed(2); box.appendChild(s); }
  }

  function init(scope) {
    var root = scope || document;
    var boxes = root.querySelectorAll('[data-buybox]');
    for (var k = 0; k < boxes.length; k++) initBuyBox(boxes[k]);
    var rit = root.querySelectorAll('[data-ritual]');
    for (k = 0; k < rit.length; k++) { initPhrases(rit[k]); initStars(rit[k]); }
    drawAll();
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(drawAll);
    var rt;
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { clearTimeout(rt); rt = setTimeout(drawAll, 120); }).observe(document.body);
    } else {
      window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(drawAll, 120); });
    }
  });
  /* Theme editor: re-run when a section is added or changed */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
